import { MARKETING_HISTORY } from 'constant/MarketingTerms';
import TermsFrame from './TermsFrame';

const MarketingTerms = () => {
  return (
    <TermsFrame
      title="(선택) 마케팅 활용 동의"
      url="marketing-terms"
      historyData={MARKETING_HISTORY}
    />
  );
};

export default MarketingTerms;
